import React, { useContext, useRef, useEffect } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import CurrencyTextField from "@unicef/material-ui-currency-textfield";

import { AnswerContext } from "../../index";
import { Input } from "../../../../Theme";
import ListItens from "./ListItens";
import EditItem from "./EditItem";
import { Container, Form, List } from "./styles";

function StepFour() {
  const inputDescriptionRef = useRef();
  const [value, setValue] = React.useState(0);
  const { state, dispatch, WizardContext } = useContext(AnswerContext);
  const { dispatch: wizardDispatch } = useContext(WizardContext);

  function handleSubmit(event) {
    event.preventDefault();
    const printDescription = event.target.printDescription.value;
    const details = event.target.details.value;
    const price = value;
    dispatch({
      type: "ADD_ITEM",
      item: {
        printDescription,
        details,
        price: Number(price),
      },
    });
    inputDescriptionRef.current.focus();
    event.target.reset();
  }

  useEffect(() => {
    wizardDispatch({
      type: "SET_IS_COMPLETE",
      isComplete: state.itens.length > 0 ? true : false,
    });
  }, [state]);

  return (
    <Container>
      {state.inEditing.status === true ? (
        <EditItem />
      ) : (
        <Form onSubmit={handleSubmit}>
          <TextField
            name="printDescription"
            placeholder="Ex: Pão Tradicional"
            required
            inputRef={inputDescriptionRef}
            autoFocus={false}
            label="Descrição"
            variant="outlined"
            autoComplete="off"
            size="medium"
          />
          <TextField
            name="details"
            placeholder="Ex: farinha de trigo, castanhas ..."
            label="Detalhes (opcional)"
            variant="outlined"
            fullWidth
            autoComplete="off"
            size="medium"
          />
          <CurrencyTextField
            value={value}
            onChange={(ev, value) => setValue(value)}
            label="Preço"
            style={{ width: "120px" }}
            variant="outlined"
            placeholder="0"
            currencySymbol="R$"
            name="price"
            required
            minimumValue="0"
            outputFormat="number"
            decimalCharacter=","
            digitGroupSeparator="."
            size="medium"
          />

          <div>
            <Button type="submit" variant="contained" color="primary">
              Adicionar
            </Button>
          </div>
        </Form>
      )}

      <List>
        <h3>Lista de opções</h3>
        <ListItens />
      </List>
    </Container>
  );
}

export default StepFour;
